import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useGetProjectMutation } from "../../redux/slices/projectApiSlice";
import { CustomLoader } from "../../shared/components/others";
import ProjectIntegrationForm from "./forms/projectIntegrationForm";
import ProjectSettingsForm from "./forms/projectSettingsForm";

const Project = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [getProject, { isLoading: getLoading }] = useGetProjectMutation();

  const handleGetSingle = async (id) => {
    try {
      const res = await getProject({ id }).unwrap();
      const sanitizedData = Object.fromEntries(
        Object.entries(res?.data || {}).map(([key, value]) => [
          key,
          value === null ? "" : value,
        ])
      );
      setProject(sanitizedData);
    } catch (error) {}
  };

  useEffect(() => {
    handleGetSingle(id);
  }, [id]);

  if (getLoading || project === null) {
    return (
      <div className="flex items-center">
        <CustomLoader />
      </div>
    );
  }

  const { platform, name, url, favicon, integration_data, export_data } =
    project;
  const projectInfos = { platform, name, url, favicon };

  return (
    <div className="mt-3 px-2 pl-6 pr-6">
      <Helmet>
        <title>Projet - {projectInfos.name}</title>
        <meta
          name="description"
          content="Vision générale de votre compte et de vos activités."
        />
      </Helmet>

      {/* PROJECT INFOS */}
      <div className="px-2 pl-6 pr-6">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center">
            {/* Favicon */}
            <img
              src={projectInfos.favicon}
              alt={`${projectInfos.name} favicon`}
              className="w-10 h-10 mr-4"
            />
            <div>
              {/* Name */}
              <h1 className="text-4xl text-black font-bold font-Roboto">
                {projectInfos.name}
              </h1>
              {/* URL */}
              <a
                href={projectInfos.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray hover:underline hover:text-black text-md"
              >
                {projectInfos.url}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT EXPORT AND INTEGRATION DATAS  */}
      <div className="sm:flex sm:space-x-4">
        <div className="sm:w-3/5">
          <div className="p-6 mb-5 mx-auto flex flex-col bg-white shadow-default rounded-2xl">
            <h2 className="text-xl font-semibold">
              Paramètres d'export par défaut
            </h2>
            <p className="text-sm mb-4">
              Choisis les paramètres que tu souhaites appliquer par défaut lors
              de l'export des contenus vers ton site. Tu pourras également les
              modifier directement lors de l'export depuis l'éditeur.
            </p>
            <ProjectSettingsForm
              platform_name={projectInfos.platform}
              exportData={export_data}
              project={project}
              setProject={setProject}
            />
          </div>
        </div>

        <div className="sm:w-2/5">
          <div className="p-6 mb-5 mx-auto flex flex-col bg-white shadow-default rounded-2xl">
            <h2 className="text-xl font-semibold">Modifier l'intégration</h2>
            <ProjectIntegrationForm
              platform_name={projectInfos.platform}
              integrationData={integration_data}
              project={project}
              setProject={setProject}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
